export type OpcionDeFiltro = {valor: string; etiqueta: string; cantidad: number};

// Convierte la lista que entrega la API (valor y conteo, a veces con
// etiqueta) en opciones para un selector de filtro.
export const opcionesDe = (
  lista: Array<{valor: string; cantidad: number; etiqueta?: string}> | undefined,
  etiqueta?: (v: string) => string,
): OpcionDeFiltro[] =>
  (lista ?? []).map(o => ({
    valor: o.valor,
    etiqueta: o.etiqueta ?? (etiqueta ? etiqueta(o.valor) : o.valor),
    cantidad: o.cantidad,
  }));
